import React from 'react';
import PropTypes from 'prop-types';

const ModalFooter = ({ children, ...otherProps }) => (
    <div className="gds-modal__footer -text-right" {...otherProps}>
        {children}
    </div>
);

ModalFooter.propTypes = {
    children: PropTypes.node,
};

export default ModalFooter;
